import React, { useState, useEffect, useRef } from 'react';

import GeneralStatistics from '../components/home/GeneralStatistics';

import InteractiveMapHome from '../components/home/InteractiveMapHome';
import PopularDestinationsHome from '../components/home/PopularDestinationsHome';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import InstagramFeedHome from '../components/home/InstagramFeedHome';
import WeatherHome from '../components/home/WeatherHome';
import DownLoadMobileApp, { AndroidApp } from '../components/DownLoadMobileApp';
import MobileAppHome from '../components/home/MobileAppHome';
import HomeImage from '../components/home/HomeImage';
import EventsHomeModal from '../components/home/EventsHomeModal';
import AccessibilityHomeModal from '../components/home/AccessibilityHomeModal';
import AccessibilityPointsModal from '../components/AccessibilityPointsModal';
import AgiosPavlosHome from '../components/home/AgiosPavlosHome';

const MainBody = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 100px;

  @media (max-width: 768px) {
    padding: 50px 40px; // Or 20px or 24px — no scroll bar now
    font-size: 18px;
  }
`;

const DownloadAppContainer = styled.div`
  // padding: 30px;
`;

const Home = () => {

   const [accessibilityOpen, setAccessibilityOpen] = useState(false);

  return (
    <div style={{ overflowX: 'hidden' }}>
        <HomeImage/>
        <MainBody>
            <GeneralStatistics/>
            <PopularDestinationsHome/>
            <InteractiveMapHome/>
            <EventsHomeModal/>
            <AccessibilityHomeModal setAccessibilityOpen={setAccessibilityOpen} />
            <AccessibilityPointsModal
              isOpen={accessibilityOpen}
              onClose={() => setAccessibilityOpen(false)}
            />
          
            {/* <WeatherHome/> */}
           <MobileAppHome/>
           <AgiosPavlosHome/>

        </MainBody>      
    </div>
   
  )
}

export default Home;
